import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {formatDate} from '@angular/common';
import {AccountService} from '../../account/account.service';
import {AuthService} from '../../authentication/auth.service';
import {Device, FORM_TYPE, Kit} from '../../models';
import * as _ from 'underscore';
import {ToastrService} from 'ngx-toastr';
import {BehaviorSubject} from 'rxjs';
import {SideNavService} from '../../layouts/side-menu/sidenav/sidenav.service';


@Component({
  selector: 'app-kit-view',
  templateUrl: './kit-view.component.html',
  styleUrls: ['./kit-view.component.css']
})
export class KitViewComponent implements OnInit {
  toDate: any;
  fromDate: any;
  fromString: string;
  toString: string;

  deviceId;

  kit: Kit;
  error;
  isDataFetched = false;

  xPointsCount = 8;
  graphRangeType;
  currentGraphRangeType = 0;

  kits: Kit[];
  selectedKit: Kit;
  formType = FORM_TYPE.EDIT;
  showForm = false;
  devices: Device[];
  devicesAll: Device[];
  devicesOfKit: Device[];
  isCloning = false;

  graphs;
  properties;

  redrawGraphEvent = new BehaviorSubject(null);
  graphDataObservable = this.redrawGraphEvent.asObservable();


  constructor(private route: ActivatedRoute, private router: Router, private toaster: ToastrService,
              private spinner: NgxSpinnerService, private accountService: AccountService, private sideNavService: SideNavService,
              private authService: AuthService) {
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.deviceId = params['deviceId'];
    });

    const lastGraphRangeType = parseInt(localStorage.getItem('graphRangeType' + this.deviceId), 10);
    this.graphRangeType = lastGraphRangeType ? lastGraphRangeType : 0;

    const temp = ((window.innerWidth * 0.55) / 80);
    this.xPointsCount = temp - temp % 1;
    this.getKit();
    const today = new Date();
    this.toDate = today;
    this.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
  }

  onKitUpdated() {
    this.showForm = false;
    this.isCloning = false;
    this.properties = null;
    const url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(url);
    });
  }

  getKit() {
    this.spinner.show();
    this.accountService.getKit(this.deviceId)
      .subscribe(response => {
        this.kit = response.content;
        const firstDevice = this.kit.devices[0];
        this.accountService.deviceName.next(firstDevice ? String(firstDevice) : '');
        this.loadGraph();
      }, error => {
        this.spinner.hide();
      });
  }

  hideForm() {
    this.isCloning = false;
    this.showForm = false;
  }

  getKits() {
    this.accountService.getKits().subscribe(response => {
      this.kits = response.content;
      this.isDataFetched = true;
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }

  editKit(kit: Kit) {
    this.accountService.getKit(this.deviceId).subscribe(response => {
      this.selectedKit = response.content;
      this.formType = FORM_TYPE.EDIT;
      this.devices = Object.assign([], this.devicesAll);
      this.devicesOfKit = this.selectedKit.devices.map(device => {
        return _.findWhere(this.devices, {id: device});
      });
      this.selectedKit['kitModel'] = this.selectedKit.model.id;
      this.selectedKit['soilType'] = this.selectedKit.metaData ? this.selectedKit.metaData.soilType : '';
      this.showForm = true;
    }, error => {
      console.error('Error fetching kit:', error);
    });
  }

  loadGraph() {
    this.currentGraphRangeType = this.graphRangeType;
    localStorage.setItem('graphRangeType' + this.deviceId, '' + this.graphRangeType);
    const today = new Date();

    if (this.graphRangeType === 2) {
      this.toDate = today;
      this.fromDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    } else if (this.graphRangeType === 1) {
      this.toDate = today;
      this.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    } else if (this.graphRangeType === 0) {
      this.toDate = today;
      this.fromDate = today;
    }
    this.toString = formatDate(this.toDate, 'yyyy-MM-dd', 'lk');
    this.fromString = formatDate(this.fromDate, 'yyyy-MM-dd', 'lk');
    this.spinner.show();
    this.accountService.getDeviceHistoryAll(this.deviceId, this.fromString, this.toString)
      .subscribe(data => {
        if (data.statusCode === 'E1003') {
          this.error = 'No Data Available';
        }
        this.graphs = data.content || null;
        this.isDataFetched = true;
        this.redrawGraphEvent.next(this.graphs);
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
      }, () => {
        this.spinner.hide();
      });
  }

  getKitProperties() {
    if (!this.properties) {
      const allProperties: any[] = Object.assign([], this.kit.properties);
      const batteryIndex = allProperties.findIndex(p => p.displayName === 'Battery');
      let batteryProp = batteryIndex > -1 ? allProperties.splice(batteryIndex, 1)[0] : null;
      const battery = this.kit.battery;
      if (!batteryProp && battery) {
        batteryProp = {
          number: allProperties.length, displayValue: battery.reading + '%', displayName: 'Battery',
          code: '-10', time: '', alert: battery.low > battery.reading, error: false, showThreshold: false
        };
      }
      if (batteryProp) {
        if (!batteryProp.displayValue.endsWith('%')) {
          batteryProp.displayValue = batteryProp.displayValue + '%';
        }
        allProperties.push(batteryProp);
      }
      this.properties = allProperties;
    }
    return this.properties;
  }

  isSideNavVisible() {
    return this.sideNavService.isSideNavVisible;
  }

  isSuperUser() {
    return AuthService.isSuperAdmin();
  }
}
